import { ca } from '@cian/analytics';
import { getClientDeviceType } from '../../../../../../shared/utils';

export const trackPhotoLoadSuccess = trackingCategory => {
  ca('eventSite', {
    name: 'oldevent',
    category: trackingCategory,
    action: 'photo_upload',
    label: 'success',
  });
};

export const trackPhotoLoadError = (errorCode, trackingCategory) => {
  const siteType = getClientDeviceType();

  ca('eventSite', {
    name: 'oldevent',
    category: trackingCategory,
    action: 'photo_upload',
    label: 'error',
    page: {
      pageType: 'AddForm',
      siteType,
      error_code: errorCode,
    },
  });
};

export const trackPhotoDeleteSuccess = trackingCategory => {
  ca('eventSite', {
    name: 'oldevent',
    category: trackingCategory,
    action: 'photo_delete',
    label: 'success',
  });
};

export const trackPhotosHintScrollToEnd = (adAnalyticsCategory) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'hint_scroll_to_end',
    label: 'photos',
  });
};

export const trackDescriptionHintScrollToEnd = (adAnalyticsCategory) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'hint_scroll_to_end',
    label: 'description',
  });
};
